import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import useAppUtilities from '../../hooks/useAppUtilities'
import {
  setContentCreatorBannerShow,
  setIsInfluencerModalOpen,
} from '../../store/influencer/contentCreator'
import CloseButton from '../ui/button/CloseButton'

const ContentCreatorBanner: React.FC = () => {
  const { dispatch } = useAppUtilities()

  const onCloseBanner = (): void => {
    dispatch(setContentCreatorBannerShow(false))
  }
  return (
    <Box position="relative" height="52px">
      <Box
        component="img"
        src="/new/images/content-creator-banner.svg"
        width="100%"
        height="100%"
        sx={{
          objectFit: 'cover',
        }}
        alt="Content Creator Banner"
      />
      <Box
        position="absolute"
        top={0}
        left={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        sx={{
          px: { xs: '16px', md: '0px' },
          pr: { xs: '30px', md: '0px' },
        }}
      >
        <Typography
          color="background.paper"
          variant="subtitle1"
          fontWeight={600}
        >
          Are You a Content Creator? Work with Restaurants Today!
        </Typography>

        <Button
          variant="contained"
          sx={{
            ml: 1,
          }}
          onClick={() => {
            dispatch(setContentCreatorBannerShow(false))
            dispatch(setIsInfluencerModalOpen(true))
          }}
        >
          Apply Now
        </Button>
      </Box>
      <Box
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100%"
        top={0}
        right={8}
        sx={{ cursor: 'pointer', color: 'white' }}
      >
        <CloseButton color="inherit" onClick={onCloseBanner} />
      </Box>
    </Box>
  )
}

export default ContentCreatorBanner
